import { useCreateFinancingPerValueFormContext } from '../components/FormManager/hooks/useCreateFinancingPerValueForm'

export function useResetFinancingForm() {
  const { reset, getValues } = useCreateFinancingPerValueFormContext()

  function resetFormValues() {
    reset({
      origin: getValues('origin'),
      integrator: getValues('integrator'),
      total_value: getValues('total_value'),
      client_name: '',
      client_birth_date: '',
      client_document: '',
      client_type: getValues('client_type'),
      client_income: 0.0,
      grace_days: '90',
      labor_value: getValues('labor_value'),
      equipments_value: getValues('equipments_value'),
      shareholder_document: '',
      client_phone: '',
      client_cep: '',
    })
  }

  return {
    resetFormValues,
  }
}
